import { motion } from "framer-motion";
import { Star, ShieldCheck, ChevronRight } from "lucide-react";

export const Hero = ({ onNavigate }) => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden grain"
    >
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1645400379459-f6fd3d963fd4?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Auto sportiva lucida"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050B18] via-[#050B18]/85 to-[#050B18]/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050B18] via-transparent to-[#050B18]/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full pt-28 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-[#7EC8E3]/40 bg-[#0A1A3A]/60 px-4 py-1.5 mb-6 backdrop-blur">
            <ShieldCheck size={15} className="text-[#7EC8E3]" />
            <span className="text-xs tracking-[0.2em] text-[#A0E0FF] font-semibold uppercase">
              Detailing Premium
            </span>
          </div>

          <h1
            data-testid="hero-title"
            className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]"
          >
            Il tuo abitacolo <br />
            <span className="text-metallic">come nuovo</span>
          </h1>

          <p
            data-testid="hero-subtitle"
            className="mt-6 text-lg sm:text-xl text-slate-300 font-medium max-w-xl"
          >
            Detailing professionale per auto di ogni dimensione. Prodotti
            professionali, risultati garantiti e finiture impeccabili.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-booking"
              onClick={() => onNavigate("prenota")}
              className="btn-silver rounded-full px-8 py-4 text-base inline-flex items-center justify-center gap-2"
            >
              Prenota il tuo servizio <ChevronRight size={18} />
            </button>
            <button
              data-testid="hero-cta-services"
              onClick={() => onNavigate("servizi")}
              className="btn-outline-blue rounded-full px-8 py-4 text-base font-semibold"
            >
              Scopri i pacchetti
            </button>
          </div>

          <div className="mt-12 flex items-center gap-8">
            <div data-testid="hero-stat-rating">
              <div className="flex items-center gap-1 text-3xl font-extrabold text-metallic font-display">
                5.0 <Star size={20} className="fill-[#A0E0FF] text-[#A0E0FF]" />
              </div>
              <div className="text-xs uppercase tracking-widest text-slate-400 mt-1">
                Valutazione clienti
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
